import {change} from 'redux-form';
import {FOODIT_LOCALSTORAGE} from '../constants/constant';
import {showServerErrorAlert} from './error.action';
import {removeValueFromLocalStorage} from '../helpers/localStorage.helper';
import ReportErrorApi from '../api/reporterror.api';

export function changeFormValue(form, field, value) {
  return dispatch => dispatch(change(form, field, value));
}

export const sendSlackMessage = (restaurant, message, url) => dispatch => {
  return ReportErrorApi.sendMessage(restaurant, message, url)
    .then(() => {
      removeValueFromLocalStorage(FOODIT_LOCALSTORAGE.ORDER_FAILED);
    })
    .catch(error => {
      dispatch(showServerErrorAlert(true));
      throw error;
    });
};



// WEBPACK FOOTER //
// ./actions/form.action.js